
import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import { Helmet } from "react-helmet";
import Fade from "react-reveal/Fade";
import "./About.css";

const OFFICE_LOCATION = {
  lat: 32.084890,
  lng: 34.800629
};

const OFFICE_ADDRESS = "רחוב שוהם 5, רמת גן";
const PHONE_NUMBER = "052-4816141";
const EMAIL = "shani.aviv.arch@gmail.com";
const WAZE_URL =
  "https://waze.com/ul?ll=32.084422,34.800719&navigate=yes";

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTime: "",
      isOpen: false
    };

    this.updateBusinessHours = this.updateBusinessHours.bind(this);
  }

  componentDidMount() {
    this.updateBusinessHours();
    this.timer = setInterval(this.updateBusinessHours, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  updateBusinessHours() {
    const now = new Date();

    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Jerusalem",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(now);

    const getPart = (type) => {
      const part = parts.find((item) => item.type === type);
      return part ? part.value : "";
    };

    const weekday = getPart("weekday");
    const hour = Number(getPart("hour"));
    const minute = Number(getPart("minute"));

    const totalMinutes = hour * 60 + minute;
    const workingDay = ["Sun", "Mon", "Tue", "Wed", "Thu"].includes(weekday);

    const isOpen =
      workingDay &&
      totalMinutes >= 8 * 60 &&
      totalMinutes < 20 * 60;

    this.setState({
      currentTime:
        String(hour).padStart(2, "0") +
        ":" +
        String(minute).padStart(2, "0"),
      isOpen
    });
  }

  render() {
    const { google } = this.props;
    const { currentTime, isOpen } = this.state;

    const aboutSchema = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "אודות רישוי עסקים ישראל",
      url: "https://rishuy-asakim.co.il/about",
      description:
        "הכירו את שני אדרעי מרישוי עסקים ישראל. ייעוץ וליווי בתחום רישוי עסקים בישראל.",
      mainEntity: {
        "@type": "Organization",
        name: "רישוי עסקים ישראל",
        url: "https://rishuy-asakim.co.il/",
        email: EMAIL,
        telephone: PHONE_NUMBER,
        address: {
          "@type": "PostalAddress",
          streetAddress: "שוהם 5",
          addressLocality: "רמת גן",
          addressCountry: "IL"
        }
      }
    };

    return (
      <main className="about-page" dir="rtl">
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(aboutSchema)}
          </script>
        </Helmet>

        <section className="textttttt">
          <Fade top>
            <div className="about-heading">
              <span className="about-eyebrow">
                רישוי עסקים ישראל
              </span>

              <h1>אודות רישוי עסקים ישראל</h1>

              <div className="about-heading-line"></div>

              <p className="about-lead">
                שני אדרעי – ייעוץ וליווי מקצועי בתחום רישוי עסקים בישראל.
              </p>

              <p className="about-description">
                אנו מעניקים ליווי והכוונה בתהליכי רישוי עסקים,
                תוך התאמת השירות לצורכי העסק ולדרישות הרשויות הרלוונטיות.
                המטרה שלנו היא לסייע לכם להתקדם בתהליך בצורה מסודרת,
                מקצועית וברורה.
              </p>
            </div>
          </Fade>

          <section className="about-contact-section" aria-labelledby="contact-heading">
            <div className="about-section-heading">
              <h2 id="contact-heading">נשמח לעמוד לשירותכם</h2>
              <p>כל פרטי ההתקשרות במקום אחד</p>
            </div>

            <div className="cards">
              <article className="card">
                <div className="about-card-icon" aria-hidden="true">📞</div>
                <h3>טלפון</h3>
                <p>{PHONE_NUMBER}</p>
                <a href="tel:0524816141" className="btn">
                  חייג עכשיו
                </a>
              </article>

              <article className="card">
                <div className="about-card-icon" aria-hidden="true">📧</div>
                <h3>דואר אלקטרוני</h3>
                <p>{EMAIL}</p>
                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${EMAIL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  שלח מייל
                </a>
              </article>

              <article className="card">
                <div className="about-card-icon" aria-hidden="true">📍</div>
                <h3>משרדנו</h3>
                <p>{OFFICE_ADDRESS}</p>
                <a
                  href={WAZE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  ניווט ב-Waze
                </a>
              </article>

              <article className="card">
                <div className="about-card-icon" aria-hidden="true">🕒</div>
                <h3>שעות פעילות</h3>

                <p className="about-current-time">
                  שעון ישראל: {currentTime}
                </p>

                <ul className="hours">
                  <li>ראשון - חמישי: 08:00 - 20:00</li>
                  <li>שישי: סגור</li>
                  <li>שבת: סגור</li>
                </ul>

                <span
                  className={`status ${isOpen ? "open" : "closed"}`}
                  aria-live="polite"
                >
                  ● {isOpen ? "פתוח עכשיו" : "סגור עכשיו"}
                </span>
              </article>
            </div>
          </section>
        </section>

        <section className="about-map-section" aria-labelledby="map-heading">
          <div className="about-section-heading">
            <h2 id="map-heading">איך מגיעים אלינו?</h2>
            <p>המשרד ממוקם ברחוב שוהם 5, רמת גן</p>
          </div>

          <div
            className="google-maps"
            role="region"
            aria-label="מפת מיקום המשרד ברמת גן"
          >
            {google && (
              <Map
                google={google}
                zoom={16}
                initialCenter={OFFICE_LOCATION}
                center={OFFICE_LOCATION}
                fullscreenControl={true}
                zoomControl={true}
                streetViewControl={true}
                mapTypeControl={false}
              >
                <Marker
                  position={OFFICE_LOCATION}
                  title={`רישוי עסקים ישראל - ${OFFICE_ADDRESS}`}
                />
              </Map>
            )}
          </div>

          <a
            href={WAZE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn about-map-button"
          >
            ניווט למשרד באמצעות Waze
          </a>
        </section>
      </main>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0",
  language: "he",
  region: "IL"
})(About);
